/* unplugin-vue-components disabled */import script from "./H5ChannelNav.vue?vue&type=script&setup=true&lang=js"
export * from "./H5ChannelNav.vue?vue&type=script&setup=true&lang=js"

import "./H5ChannelNav.vue?vue&type=style&index=0&id=344a58c6&scoped=true&lang=scss"

import exportComponent from "../../../../../../../Users/mac/myproject/deepsage/deepsage_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-344a58c6"]])

export default __exports__